module.exports = __webpack_public_path__ + "img/canvas.a82d33fe.png";